<template>
  <div class="shake-setting">
    <!-- 抖动方向 -->
    <div class="direction">
      <div class="direction__title">
        抖动方向
      </div>
      <div class="direction__content">
        <div class="clock-wrapper">
          <div class="clock-grad clock-top"></div>
          <div class="clock-grad clock-right"></div>
          <div class="clock-grad clock-left"></div>
          <div class="clock-grad clock-bottom"></div>
          <div class="clock-base">
            <div class="click-indicator"></div>
            <div class="clock-second" :style="{transform: `rotate(${direction}deg)`}">
              <div class="clock-arrow"></div>
              <div v-dragHandle data-type="direction" class="clock-drag-handle"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 抖动振幅 -->
    <div class="speed">
      <div class="speed__title">
        抖动振幅
      </div>
      <div class="speed__content">
        <div class="slider">
          <div class="slider-before">低</div>
          <div class="rc-slider">
            <div class="rc-slider-rail">
              <div class="content-box" v-for="i in 8" :style="{left: i * 100 / 9 + '%'}"></div>
            </div>
            <div v-dragHandle data-type="amplitude" class="rc-slider-handle" :style="{'left':  (amplitude-amplitudeR[0])/(amplitudeR[1]-amplitudeR[0])*100 + '%'}"></div>
          </div>
          <div class="slider-after">高</div>
        </div>
      </div>
    </div>
    <!-- 抖动速度 -->
    <div class="speed">
      <div class="speed__title">
        抖动速度
      </div>
      <div class="speed__content">
        <div class="slider">
          <div class="slider-before">慢</div>
          <div class="rc-slider">
            <div class="rc-slider-rail">
              <div class="content-box" v-for="i in 8" :style="{left: i * 100 / 9 + '%'}"></div>
            </div>
            <div v-dragHandle data-type="speed" class="rc-slider-handle" :style="{'left':  (speed-speedR[0])/(speedR[1]-speedR[0])*100 + '%'}"></div>
          </div>
          <div class="slider-after">快</div>
        </div>
      </div>
    </div>
    <div class="tips">
      Tips:动画属性设置实时应用
    </div>
    <div class="footer-play">
      <div @click="playStayAnim"><i class="preview-play"></i>预览动画</div>
      <div @click="cancleStayAnim"><i class="delete-stay"></i>无动画</div>
    </div>
  </div>
</template>

<script>

export default {
  props:['sprite'],
  data () {
    return {
      ANALYSIS: {category:'shake_animation_panel', action:'click_close_panel', label:'抖动动画面板-关闭面板'},
      popupType: 'shakeSetting',                         // 控制弹窗
      direction: 0,
      speed: 2,
      speedR: [0.4, 4],
      amplitude: 0.25,
      amplitudeR: [0.05, 0.5],
      spriteBox: null,
      dataType: '',
      isShow: false
    }
  },
  mounted () {
    this.$bus.on('effectSetting.shake', () => {
      this.initData()
    })
    this.$bus.on('undoRedoHandle', this._undoRedoHandle)
  },
  methods: {
    initData() {
      if(this.sprite) {
        this.isShow = true;
        let stayAnim = Object.assign({}, this.sprite.effect.stayAnim);
        if(stayAnim.type !== 'Shake') {
          this.speed = 2;
          this.direction = 0;
          this.amplitude = .25;
          this.updateEffect();
        } else {
          this.speed = stayAnim.speed;
          this.direction = stayAnim.direction;
          this.amplitude = stayAnim.amplitude;
        }
      } else {
        this.isShow = false;
      }
    },
    changeDireciton() {
      this.updateEffect();
    },
    updateEffect(cancel) {
      let code = this.sprite.effect.code
      if(this.isSpecialEffect(code)) {
        code = 'FadeIn'
      }
      this.sprite.updateEffect({
        code: code,
        entranceAnim:{
          start: this.sprite.effect.entranceAnim.start,
          end: this.sprite.effect.entranceAnim.end
        },
        pathAnim: null,
        stayAnim: cancel ? {type: 'None'}: {
          type: 'Shake',
          speed: this.speed,
          direction: + this.direction,
          amplitude: this.amplitude
        }
      }, true).then(() => {
        this.$bus.emit('updateEffect_vue', {
          sprite: this.sprite,
          effect: this.sprite.effect || {},
          type: 'path'
        });
        this.sprite.changeStyle()
      })
    },
    playStayAnim() {
      this.spriteBox = this.sprite;
      this.$bus.emit('preview_callback', {
        type: 'play',
        source: 'shake',
        startNode: this.sprite.effect.entranceAnim.end / 1000,
        stopNode: this.sprite.effect.exitAnim.start / 1000 - 0.02,
        spriteBox: this.spriteBox
      })
      this.$analysis({category:'shake_animation_panel', action:'click_preview_animation', label:'抖动动画面板_预览动画'})
    },
    cancleStayAnim() {
      this.updateEffect(true)
      this.sprite.action = null;
      this.$bus.emit('cancleStayAnim')
      this.$analysis({category:'shake_animation_panel', action:'click_delete_animation', label:'抖动动画面板_删除动画'})
    },
    dragMousemove(e, disx, now, disy) {
      if(this.dataType === 'direction') {
        let deg = this._levelDeg(e.pageX, e.pageY, disx, disy)
        deg = Math.round(deg / 15) * 15;
        this.direction = deg;
        return;
      }
      let pre = Math.round((disx - e.pageX) / 180 * 10)
      if(this.dataType === 'amplitude') {
        this.amplitude =  (now - pre * .05) < this.amplitudeR[0] ? this.amplitudeR[0] : (now - pre * .05) > this.amplitudeR[1] ? this.amplitudeR[1] : now - pre * .05;
      } else if(this.dataType === 'speed') {
        this.speed =  (now - pre * .4) < this.speedR[0] ? this.speedR[0] : (now - pre * .4) > this.speedR[1] ? this.speedR[1] : now - pre * .4;
      }
    },
    dragMouseup(now) {
      if(this.dataType === 'direction') {
        this.$analysis({
          category: 'shake_animation_panel', 
          action: 'drag_shake_orientation_' + this.direction, 
          label: '抖动动画面板_抖动方向_' + this.direction
        })
      }else if(this.dataType === 'amplitude') {
        this.amplitude = Math.round(this.amplitude * 100) / 100;
        this.$analysis({
          category: 'shake_animation_panel', 
          action: 'drag_shake_amplitude_' + this.amplitude, 
          label: '抖动动画面板-振幅_' + this.amplitude
        })
      } else {
        this.speed = Math.round(this.speed * 10) / 10;
        this.$analysis({
          category: 'shake_animation_panel', 
          action: 'drag_shake_speed_' + this.speed, 
          label: '抖动动画面板_速度_' + this.speed
        })
      }
      this.dataType = ''
      this.updateEffect()
    },
    _levelDeg: function(x1, y1, cx, cy) {
      var dx = x1 - cx,
          dy = y1 - cy,
          deg = 360*Math.atan2(dy,dx) / (2*Math.PI)
      if(dx > 0 && dy == 0) {
        // x轴正方向上
        deg = 0;
      } else if(dx < 0 && dy == 0) {
        // x轴负方向
        deg = 180;
      } else if( dy > 0 && dx == 0) {
        // y轴正方向
        deg = 90;
      }else if(dy < 0 && dx == 0) {
        // y轴负方向
        deg = 270;
      }else if(dx != 0 && dy < 0) {
        deg = 360 + deg
      }
      return deg
    },
    _undoRedoHandle(data) {
      if(this.isShow && data.type === 'updateSpriteEffect') {
        this.initData()
      }
    },
    isDrawEffect (code) {
      return /^(?:draw|hand|write)$/i.test('' + code);
    },
    isAppearEffect (code) {
      return /^(?:appear|type|bounce|roll)$/i.test('' + code);
    },
    isSpecialEffect (code) {
      return this.isDrawEffect(code) || this.isAppearEffect(code);
    }
  },
  directives: {
    dragHandle(el, binding, vnode) {
      let _this = vnode.context,
          now = 0,
          mousemove = null,
          mouseup = null,
          disy = 0,
          disx = 0;

      mousemove = (e) => {
        _this.dragMousemove(e, disx, now, disy)
      }
      mouseup = (e) => {
        document.removeEventListener('mousemove',mousemove);
        document.removeEventListener('mouseup',mouseup);
        _this.dragHandle = false;
        _this.dragMouseup();
        now = 0;
      }

      el.onmousedown = (e) =>{
        e.preventDefault();
        e.stopPropagation();

        _this.dragHandle = true;
        disx = e.pageX;
        disy = e.pageY;
        _this.dataType = e.target.dataset.type;
        if(_this.dataType === 'amplitude') {
          now = _this.amplitude
        }else if(_this.dataType === 'speed') {
          now = _this.speed
        }else if(_this.dataType === 'direction') {
          var dis = e.target.parentElement.parentElement.getBoundingClientRect();
          disx = dis.x + dis.width / 2;
          disy = dis.y + dis.height / 2;
          now = _this.direction;
        }

        document.addEventListener('mousemove', mousemove);
        document.addEventListener('mouseup', mouseup);
      }
    }
  },
  beforeDestroy () {
    this.$bus.off('effectSetting.shake')
    this.$bus.off('undoRedoHandle', this._undoRedoHandle);
  }
}
</script>

<style lang="scss" scoped>
.shake-setting {
  padding: 16px 15px;
  font-size: 15px;
  text-align: left;
}

.footer-play {
  margin: 25px auto 10px;
  padding-top: 22px;
  border-top: 1px solid #eee;
  width: 100%;
  display: flex;
  justify-content: space-between;

  div {
    width: 110px;
    height: 36px;
    background-color: #F0F0F8;
    text-align: center;
    line-height: 36px;
    border-radius: 3px;
    cursor: pointer;

    &:hover{
      background: #d9ddea;
    }

    i {
      display: inline-block;
      position: relative;
      top: 2px;
      width: 15px;
      height: 15px;
      margin-right: 8px;
    }

    .preview-play {
      background: url('../../../../static/svg/preview-play.svg') no-repeat;
    }
    .delete-stay {
      background: url('../../../../static/svg/delete.svg') no-repeat;
    }
  }
}

.direction {
  &__content {
    margin: 15px auto 32px;
  }
}

.speed {
  margin-top: 22px;
  &__content {
    margin: 15px auto;
    text-align: center;
  }
}

.tips {
  margin: 22px 0;
  color: #9692A9;
}

.slider {
  width: 100%;
  display: flex;
  justify-content: space-between;
  
  div {
    font-size: 12px;
  }
}

.rc-slider-rail {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 6px;
  border: 2px solid #d9ddea;
  border-top: none;
}

.content-box {
  border-left: 2px solid #d9ddea;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 2px;
  position: absolute;
  top: 1px;
  margin-left: -1px;
}

.rc-slider {
  position: relative;
  height: 15px;
  padding: 5px 0;
  width: 180px;
  -ms-touch-action: none;
  touch-action: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .rc-slider-handle {
    position: absolute;
    margin-left: -8px;
    margin-top: -5px;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 13px solid #474261;
    cursor: -webkit-grab;
    cursor: grab;
    -ms-touch-action: pan-x;
    touch-action: pan-x;
  }
}

.clock-wrapper{
  position: relative;
  width: 140px;
  height: 140px;
  margin: auto;
  border: 1px dashed #ddd;
  border-radius: 50%;
}
.clock-base{
  position: absolute;
  width: 140px;
  height: 140px;
  border-radius: 50%;
}
.click-indicator{
  position: absolute;
  z-index: 1;
  width: 140px;
  height: 140px;
}
.clock-second{
  position: absolute;
  z-index: 4;
  top: 50%;
  left: calc(50% - 10px);
  width: 75px;
  height: 2px;
  background-color: #666;
  transform-origin: 10px 1px;
}
.clock-second:after{
  content: "";
  display: block;
  position: absolute;
  left: 7px;
  bottom: -2px;
  width: 6px;
  height: 6px;
  background-color: #666;
  border: solid 2px #666;
  border-radius: 50%;
}
.clock-arrow {
  position: absolute;
  right: 2px;
  top: -4px;
  width: 10px;
  height: 10px;
  border-top: 2px solid #666;
  border-right: 2px solid #666;
  transform: rotate(43deg) skew(-15deg, -15deg);
}
.clock-drag-handle {
  width: 20px;
  height: 20px;
  position: absolute;
  right: -8px;
  top: -9px;
  cursor: pointer;
}
.clock-grad {
  position: absolute;
  background: #ddd;
  width: 2px;
  height: 2px;
}
.clock-top {
  height: 6px;
  left: 0;
  right: 0;
  margin: 0 auto;
}
.clock-right {
  width: 6px;
  top: 4px;
  bottom: 0;
  right: 0;
  margin: auto 0;
}
.clock-bottom {
  height: 6px;
  left: 0;
  bottom: 0;
  right: 0;
  margin: 0 auto;
}
.clock-left {
  width: 6px;
  top: 4px;
  bottom: 0;
  left: 0;
  margin: auto 0;
}
.shake-to-setting {
  width: 110px;
  height: 36px;
  background-color: #F0F0F8;
  text-align: center;
  line-height: 36px;
  border-radius: 3px;
  margin-bottom: 15px;
  cursor: pointer;

  &:hover {
    background-color: #5778fb;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/stayAnim/shakeSetting.vue